export function hideElement(elementToHide){
    elementToHide.addClass('rtpIcon-no-display')
}

export function showElement(elementToHide){
    elementToHide.removeClass('rtpIcon-no-display')
}

export function setActiveElement(element){
    element.addClass('rtp-active-toolsTabBtn');
}

export function setInActiveElement(element){
    element.removeClass('rtp-active-toolsTabBtn');
}